import { useOptionalSession } from './chunk-7QYYSJGW.js';
import { Badge } from './chunk-2WDEGOCV.js';
import { cn } from './chunk-FFX3LZW7.js';
import * as React from 'react';
import { actorDisplayName } from '@authe/fe-commons/session';
import { jsx } from 'react/jsx-runtime';
import { EventCriticality, criticalityLabel } from '@authe/fe-commons/events';

var ActorNames = React.createContext(/* @__PURE__ */ new Map());
function ActorNamesProvider({ names, children }) {
  return /* @__PURE__ */ jsx(ActorNames.Provider, { value: names, children });
}
function ActorName({ id, names, missing, className }) {
  const directory = React.useContext(ActorNames);
  const session = useOptionalSession()?.session;
  const local = names?.get(id ?? "")?.trim();
  const name = actorDisplayName(id, { self: session?.user, names: local && local !== id ? names : directory, missing });
  return /* @__PURE__ */ jsx("span", { className, title: id ? `User ID: ${id}` : void 0, children: name });
}
function useActorNameIfKnown(id) {
  const directory = React.useContext(ActorNames);
  const session = useOptionalSession()?.session;
  const subject = id?.trim();
  if (!subject) return void 0;
  const name = actorDisplayName(subject, { self: session?.user, names: directory });
  return name !== subject ? name : void 0;
}
var CRITICALITY_TONE_CLASS = {
  [EventCriticality.CRITICAL]: "bg-risk-critical/15 text-risk-critical border-risk-critical/30",
  [EventCriticality.HIGH]: "bg-risk-high/15 text-risk-high border-risk-high/30",
  [EventCriticality.MEDIUM]: "bg-risk-medium/15 text-risk-medium border-risk-medium/30",
  [EventCriticality.LOW]: "bg-muted text-muted-foreground border-border",
  [EventCriticality.SUCCESS]: "bg-risk-none/15 text-risk-none border-risk-none/30"
};
var CRITICALITY_DOT_CLASS = {
  [EventCriticality.CRITICAL]: "bg-risk-critical",
  [EventCriticality.HIGH]: "bg-risk-high",
  [EventCriticality.MEDIUM]: "bg-risk-medium",
  [EventCriticality.LOW]: "bg-muted-foreground",
  [EventCriticality.SUCCESS]: "bg-risk-none"
};
function CriticalityBadge({ level, dot, className }) {
  if (dot) {
    return /* @__PURE__ */ jsx(
      "span",
      {
        role: "img",
        "aria-label": criticalityLabel(level),
        className: cn("inline-block size-2 shrink-0 rounded-full", CRITICALITY_DOT_CLASS[level], className)
      }
    );
  }
  return /* @__PURE__ */ jsx(Badge, { variant: "outline", className: cn("border", CRITICALITY_TONE_CLASS[level], className), children: criticalityLabel(level) });
}

export { ActorName, ActorNamesProvider, CRITICALITY_DOT_CLASS, CRITICALITY_TONE_CLASS, CriticalityBadge, useActorNameIfKnown };
//# sourceMappingURL=chunk-GDC6VEN4.js.map
//# sourceMappingURL=chunk-GDC6VEN4.js.map